import { Injectable } from '@angular/core';
import { AbstractStorage } from './abstract-storage.interface';

const numberPattern = new RegExp(/^\d+$/);
const jsonPattern = new RegExp(/[\[\{].*[\}\]]/);

@Injectable()
export class LocalBrowserStorage implements AbstractStorage {
  private readonly storage: Storage = window.localStorage;

  constructor() {}

  getItem(key: string): any {
    const data = this.storage.getItem(key);

    if (!data) return null;

    if (jsonPattern.test(data)) return JSON.parse(data);
    if (numberPattern.test(data)) return parseFloat(data);

    return data;
  }

  removeItem(key: string) {
    this.storage.removeItem(key);
  }

  setItem(key: string, value: any) {
    if (typeof value === 'object') {
      this.storage.setItem(key, JSON.stringify(value));
      return;
    }

    this.storage.setItem(key, value);
  }
}
